import { useCallback, useEffect } from "react";

/**
 * Custom hook that allows to detect clicks outside of a given element.
 * @param ref The element to detect clicks outside of.
 * @param callback The callback to be called when a click outside of the element is detected.
 */
export const useOutsideClick = (
  ref: React.RefObject<HTMLElement>,
  callback: () => void
) => {
  const clickHandler = useCallback(
    ({ target }: MouseEvent) => {
      console.log("target", target);
      console.log("ref", ref.current);
      if (ref.current && !ref.current.contains(target as Node)) {
        callback();
      }
    },
    [callback, ref]
  );

  useEffect(() => {
    document.addEventListener("click", clickHandler, true);
    return () => {
      document.removeEventListener("click", clickHandler, true);
    };
  }, [clickHandler]);
};
